module.exports = __webpack_public_path__ + "static/media/Map.1c6f039b.png";